<template>
  <div>
    <BonusCampaignComponent />
  </div>
</template>

<script>
import BonusCampaignComponent from './components/Index.vue'

export default {
  name: 'BonusCampaign',
  components: {
    BonusCampaignComponent,
  },
}
</script>
